<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> User Name </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="userName" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Contact Person Name </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="contactPersonName" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> District Code </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="districtCode" clearable name="districtCode">
                <el-option
                  v-for="district in districtList"
                  :label="district.districtNameEn"
                  :value="district.districtCode"
                  :key="district.districtCode"
                  class="ng-binding"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button
                    @click="gotoDetail"
                    v-if="checkPermission('Schooluser_LIST_ADD')"
                    >{{ $t("message.Add") }}</el-button
                  >
                  <el-button
                    @click="showWarning"
                    v-if="checkPermission('Schooluser_LIST_DEL')"
                    >{{ $t("message.Delete") }}</el-button
                  >
                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="schoolName"
                  label="School Name"
                ></el-table-column>
                <el-table-column prop="userName" label="User Name" width="170">
                </el-table-column>
                <el-table-column
                  prop="contactPersonName"
                  label="Contact Person Name"
                >
                </el-table-column>
                <el-table-column prop="districtNameEn" label="District Name">
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleDbClick(scope.row)"
                      icon="el-icon-edit"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "ASC",
      sortField: "sortOrder",
      status: "",
      statusObj: [],
      typeObj: [],
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: false,
      userName: "",
      contactPersonName: "",
      districtCode: "",
      districtList: [],
    };
  },
  components: {
    StatusBtn,
  },
  created() {
    if (this.checkPermission("J Channel_LIST_ORDER")) {
      this.canDrag = true;
    }
    this.getDistrictList();
  },
  methods: {
    async init() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.userName = this.userName;
      objdata.contactPersonName = this.contactPersonName;
      objdata.districtCode = this.districtCode;

      objdata.apiUrl = this.apiConfig.schooluserList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.schoolUsers;
      this.total = data.data.result.total;
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/schoolDetail",
        query: {
          id: row.id,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/schoolDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.schoolUserDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    async getDistrictList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtList", data.data.result);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
